import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getReq } from './axios';
import { allReferenceParams } from './models';
var BASE_URL = "".concat(apiUrl, "/reference");
export var getTotalGivenAmountBreakdown = function getTotalGivenAmountBreakdown(params) {
  return getReq("".concat(BASE_URL, "/total-given-amount-breakdown"), {
    params: allReferenceParams(params)
  });
};
export var getTotalFuturePaymentsBreakdown = function getTotalFuturePaymentsBreakdown(params) {
  return getReq("".concat(BASE_URL, "/total-future-payments-breakdown"), {
    params: allReferenceParams(params)
  });
};
export var getExpectedPrincipalByWeek = function getExpectedPrincipalByWeek(params) {
  return getReq("".concat(BASE_URL, "/expected-principal-by-week"), {
    params: allReferenceParams(params)
  });
};
export var getCurrentMonthReference = function getCurrentMonthReference(params) {
  return getReq("".concat(BASE_URL, "/current-month-reference"), {
    params: allReferenceParams(params)
  });
};
export var getPastPrincipleByMonth = function getPastPrincipleByMonth(params) {
  return getReq("".concat(BASE_URL, "/past-principal-by-month"), {
    params: allReferenceParams(params)
  });
};
export var getCollectedPaymentsBreakdown = function getCollectedPaymentsBreakdown(params) {
  return getReq("".concat(BASE_URL, "/collected-payments-breakdown"), {
    params: allReferenceParams(params)
  });
};
export var getAllPaymentsBreakdown = function getAllPaymentsBreakdown(params) {
  return getReq("".concat(BASE_URL, "/all-payments-breakdown"), {
    params: allReferenceParams(params)
  });
};
export var getExpectedFundsReference = function getExpectedFundsReference(params) {
  return getReq("".concat(BASE_URL, "/expected-funds-reference"), {
    params: allReferenceParams(params)
  });
};
export var getCollectedFundsPastPeriodBreakdown = function getCollectedFundsPastPeriodBreakdown(params) {
  return getReq("".concat(BASE_URL, "/collected-funds-past-period-breakdown"), {
    params: allReferenceParams(params)
  });
};
export var getLatePaymentsReferenceBreakdown = function getLatePaymentsReferenceBreakdown(params) {
  return getReq("".concat(BASE_URL, "/late-payments-reference-breakdown"), {
    params: allReferenceParams(params)
  });
};
export var getInterestAndFeesReference = function getInterestAndFeesReference(params) {
  return getReq("".concat(BASE_URL, "/interest-and-fees-reference"), {
    params: allReferenceParams(params)
  });
};
export var getLatePaymentsReference = function getLatePaymentsReference(params) {
  return getReq("".concat(BASE_URL, "/late-payments-reference"), {
    params: allReferenceParams(params)
  });
};
export var getContractsReference = function getContractsReference(params) {
  return getReq("".concat(BASE_URL, "/all-contracts-reference"), _objectSpread({
    params: allReferenceParams(params)
  }, (params === null || params === void 0 ? void 0 : params["export"]) && {
    responseType: 'blob'
  }));
};
export var getAccountingReference = function getAccountingReference(params) {
  return getReq("".concat(BASE_URL, "/accounting-reference"), _objectSpread({
    params: allReferenceParams(params)
  }, (params === null || params === void 0 ? void 0 : params["export"]) && {
    responseType: 'blob'
  }));
};
export var getIssuedCreditsReference = function getIssuedCreditsReference(params) {
  return getReq("".concat(BASE_URL, "/issued-credits-reference"), _objectSpread({
    params: allReferenceParams(params)
  }, (params === null || params === void 0 ? void 0 : params["export"]) && {
    responseType: 'blob'
  }));
};
export var getDueInterestReference = function getDueInterestReference(params) {
  return getReq("".concat(BASE_URL, "/due-interest-reference"), _objectSpread({
    params: allReferenceParams(params)
  }, (params === null || params === void 0 ? void 0 : params["export"]) && {
    responseType: 'blob'
  }));
};
export var getPayedByMonthReference = function getPayedByMonthReference(params) {
  return getReq("".concat(BASE_URL, "/payed-by-month-reference"), _objectSpread({
    params: allReferenceParams(params)
  }, (params === null || params === void 0 ? void 0 : params["export"]) && {
    responseType: 'blob'
  }));
};
export var getHomeVisitFeeReference = function getHomeVisitFeeReference(params) {
  return getReq("".concat(BASE_URL, "/home-visit-fee-reference"), _objectSpread({
    params: allReferenceParams(params)
  }, (params === null || params === void 0 ? void 0 : params["export"]) && {
    responseType: 'blob'
  }));
};
export var getPrincipalsByMonthReference = function getPrincipalsByMonthReference(params) {
  return getReq("".concat(BASE_URL, "/principals-by-month-reference"), _objectSpread({
    params: allReferenceParams(params)
  }, (params === null || params === void 0 ? void 0 : params["export"]) && {
    responseType: 'blob'
  }));
};
export var getPaymentsReference = function getPaymentsReference(params) {
  return getReq("".concat(BASE_URL, "/payments-reference"), _objectSpread({
    params: allReferenceParams(params)
  }, (params === null || params === void 0 ? void 0 : params["export"]) && {
    responseType: 'blob'
  }));
};
export var getPaymentsByMonthPerCreditReference = function getPaymentsByMonthPerCreditReference(params) {
  return getReq("".concat(BASE_URL, "/payments-by-month-per-credit-reference"), _objectSpread({
    params: allReferenceParams(params)
  }, (params === null || params === void 0 ? void 0 : params["export"]) && {
    responseType: 'blob'
  }));
};